import React from "react";
import classNames from "classnames";

import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

// Same placeholder as the WBS one: a unit, then two indented ones.
function Loader() {
  return (
    <div className={styles.loader}>
      {new Array(3).fill(0).map((_, index) => (
        <Skeleton
          key={index}
          className={classNames(styles.unit, {
            [styles.indented]: index !== 0,
          })}
        />
      ))}
    </div>
  );
}

export { Loader };
